const getCommonClassNameDefault = ()=>'';
const getCommonButtonTypeDefault = ()=>'button';
const getCommonFormVariantDefault = ()=>'medium';
const getCommonAutoCompleteDefault = ()=>'off';
const getAutoCompletePropDescription = ()=>'Verdien til autoComplete må være "on", "off" eller en av de andre lovlige verdiene beskrevet på <a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete" target="msndoc">MDN</a>';

export { getCommonButtonTypeDefault as a, getCommonFormVariantDefault as b, getCommonAutoCompleteDefault as c, getAutoCompletePropDescription as d, getCommonClassNameDefault as g };
